var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBranch = function SvgBranch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M50 10a2 2 0 0 0-2 2v7h-9.172v20H32v-8a2 2 0 0 0-2-2H12a2 2 0 0 0-2 2v18a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2v-8h6.828v20H48v7a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V50a2 2 0 0 0-2-2H50a2 2 0 0 0-2 2v9h-7.172V21H48v9a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V12a2 2 0 0 0-2-2zm18 20H50V12h18zM50 68h18V50H50zM12 49V31h18v18z",
    clipRule: "evenodd"
  })));
};
export default SvgBranch;